'use strict';

var __chunk_1 = require('./chunk-ba04ad2f.js');

function takeWhile(p, as) {
  var s = __chunk_1.isString(as) ? '' : [];
  var n = as.length;

  for (var i = 0; i < n && p(as[i]); i++) {
    s = s.concat(as[i]);
  }

  return s;
}

module.exports = takeWhile;
